import { StyleSheet } from 'aphrodite';
import typography from 'defaults/typography';
import { hexToRgbA } from 'utils/styleUtil';

//All color and font related changes here. The layout will be in .scss file

const getSkin = (theme) => {
    const skin = theme.globalProfiles.palette;
    const myTypography = typography(theme);

    return StyleSheet.create({
        container: {
            background: skin.white
        },
        selectIcon: {
            border: `1px solid ${skin.buttonColor1}`
        },
        name: {
            ...myTypography.subtitle,
            fontSize: '14px',
            lineHeight: '19px',
            color: skin.black
        },
        designation: {
            ...myTypography.body1,
            fontSize: '9px',
            lineHeight: '12px',
            color: skin.black,
            opacity: 0.6
        },
        viewProfileButton: {
            fontFamily: 'Nunito',
            fontWeight: 'bold',
            fontSize: '10px',
            lineHeight: '14px',
            textAlign: 'center'
        },
        actorDisabled: {
            ...myTypography.body1,
            fontSize: '10px',
            lineHeight: '14px',
            color: '#FF425D',
            textAlign: 'center'
        }
    });
}

export default getSkin;
